module.exports = __webpack_public_path__ + "static/media/artworks-iv58hjb8clj5-0-t500x500-394x394.fae9464a.jpg";